enum NotificationType {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  BOTH = 'BOTH'
}

export default NotificationType